<template>
  <div id="mainDiv" ontouchstart="">
    <!-- <h1>{{speedGeneratorActive}}</h1> -->
    <div style="display: none;">   
        <i class="fas fa-2x fa-arrow-circle-up"></i>
        <i class="fas fa-2x fa-arrow-circle-down"></i>
        <i class="fas fa-pause"></i>
        <i class="fas fa-play"></i> 
    </div>
        <div id="dynamicLoadingScreen" class="outer" v-show="!areBuffersLoaded">
            <div class="middle">
                <div class="inner" id="innerClass">
                    <div class="stageSound">
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                        <div class="layerSound"></div>
                    </div>

                    <div class="loadingTxt">
                        {{demoLoadingTxt}} 
                        <br v-show="demoLoadingTxt != '' ">
                        <span v-if="loadingPrecentage > 0">{{loadingPrecentage}}% Loaded</span>
                        <span style="white-space: pre;" v-else>{{loadingReassuranceText}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="outer" v-show="areBuffersLoaded && !isSelectionMenuActive">
            <div class="middle">
                <div v-if="selectedSoundscape == `moody intro` && layerSliderPosition == 0" class="inner" id="dynamicTextBox">
                    <p class="dynamicText" style="text-align: center; font-weight: 700;">
                        <i class="fad fa-2x fa-arrow-alt-circle-up"></i>
                        <br>
                        {{introTextTop}}
                    </p>
                    <hr class="loadingLine">
                    
                    <p class="dynamicText" style="text-align: center; font-weight: 300 !important;"> 
                        <span v-show="!isAudioUnlocked"> Please Unmute Device & Press Play </span>
                        <span v-show="isAudioUnlocked"> Headphones Recommended </span>
                    </p>

                    <hr class="loadingLine">
                    <p class="dynamicText" style="text-align: center; font-weight: 700;">
                        {{introTextBottom}}
                        <br>
                        <i class="fad fa-2x fa-arrow-alt-circle-down"></i>
                    </p>
                </div>
                <div v-else class="inner" id="dynamicTextBox">
                    <p class="dynamicText noselect" style="white-space: pre-wrap;">{{dynamicText}}</p>
                </div>
            </div>
        </div>

        <div id="soundscapeSelectionBay" v-show="areBuffersLoaded" class="dropdown">
            <button class="btn btn-secondary dropdown-toggle soundscapeSelectorID threeDText sliderBoxShadow" 
                    type="button" 
                    id="dropdownMenu2" 
                    data-toggle="dropdown" 
                    data-flip="false"
                    aria-haspopup="true" 
                    aria-expanded="false"
                    @click="activateOpacity">
            <span style="text-align: center !important;"> {{selectedSoundscapeDisplay}}</span>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape1']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape1']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape1']['soundscapeName'])">
                    {{masterAudioObject['soundscape1']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape2']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape2']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape2']['soundscapeName'])">
                    {{masterAudioObject['soundscape2']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape3']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape3']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape3']['soundscapeName'])">
                    {{masterAudioObject['soundscape3']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape4']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape4']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape4']['soundscapeName'])">
                    {{masterAudioObject['soundscape4']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape5']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape5']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape5']['soundscapeName'])">
                    {{masterAudioObject['soundscape5']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape6']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape6']['--main-accentBackground']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape6']['soundscapeName'])">
                    {{masterAudioObject['soundscape6']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape7']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape7']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape7']['soundscapeName'])">
                    {{masterAudioObject['soundscape7']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape8']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape8']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape8']['soundscapeName'])">
                    {{masterAudioObject['soundscape8']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item threeDText"
                    :style="[{ 'color' : masterAudioObject['soundscape9']['--main-sliderTextColor']},
                    { 'background-color' : masterAudioObject['soundscape9']['--main-sliderColor']}]"
                    @click="initalizeAudioNewScene(masterAudioObject['soundscape9']['soundscapeName'])">
                    {{masterAudioObject['soundscape9']['soundscapeName']}}
                </button>
                <button 
                    type="button" 
                    class="dropdown-item"
                    :style="[{ 'color' : 'var(--main-creditColor)'},
                    { 'background' : 'transparent' }]"
                    target="_blank"
                    @click="goToMcCookie">
                    by Matt McCorkle
                </button>
            </div>
        </div>

        <div id="soundscapeSelectionBay" v-show="areBuffersLoaded" style="pointer-events: none; outline: none !important;">
            <div class="soundscapeSelectorID threeDText noselect dropDownHamburger"> 
                 <i class="fas fa-bars"></i>
             </div>
        </div>

        <div id="perspectiveControlBay"  v-show="areBuffersLoaded && !isSelectionMenuActive"> 
            <input 
                id="perspectiveSlider"
                type="range"
                class="sliderBoxShadow"
                v-model.number="layerSliderPosition"
                :="spaceAdjust"
                max="1" min="0" step="0.01"
                style="z-index: 4 !important;">
            </input>
            <button type="button" 
                    class="playPauseBtn sliderBoxShadow noselect threeDText" 
                    @click="speedGenerator">
                    <span v-if="speedGeneratorActive == 1"> <i class="fas fa-tachometer-slowest"></i> </span>
                    <span v-else-if="speedGeneratorActive == 2"> <i class="fas fa-tachometer-average"></i> </span>
                    <span v-else-if="speedGeneratorActive == 3"> <i class="fas fa-tachometer-fastest"></i> </span>
                    
            </button> 
        </div>

        <div id="bufferControlBay"  v-show="areBuffersLoaded && !isSelectionMenuActive"> 
            <input 
                id="bufferSliderControl"
                type="range"
                class="sliderBoxShadow"
                v-model.number="bufferPosition"
                @input="bufferChangePosition(bufferPosition);" 
                :max="bufferDuration" min="0" step="0.001"
                style="z-index: 4 !important;">
            </input>

            <button type="button" 
                    class="playPauseBtn sliderBoxShadow noselect threeDText" 
                    @click="startStopControl">
                    <span v-if="!isPauseEnabled"> <i class="fas fa-pause"></i></span>
                    <span v-if="isPauseEnabled"> <i class="fas fa-play"></i> </span>
            </button> 
        </div>

        <div class="noselect" style="z-index: 0 !important; pointer-events: none;" id="perspectiveControlBay" v-show="areBuffersLoaded && !isSelectionMenuActive"> 
            <div class="perspectiveBarText threeDText">Mood</div>
        </div>

        <div class="noselect" style="z-index: 0 !important; pointer-events: none;" id="bufferControlBay" v-show="areBuffersLoaded && !isSelectionMenuActive"> 
            <div class="timeBarText threeDText">Moment</div>
        </div>
        

        </div>
    </div>
  </div>
</template>

<script>
  import StartAudioContext from '../../node_modules/startaudiocontext/StartAudioContext.js';
  import localForage from 'localforage';
  const soundscapeControl = require('../components/soundscapeControl.js');
  export default {
data: () => ({
    //V-SHOWS
        mainPage:           false,
    //CONTROLS
        userMobile:         false,
        isMobile:           Boolean,
        iOSUser:            undefined,
        selectedSoundscape: '',
        selectedSoundscapeDisplay: '',
        defaultSoundscape:  '',
        demoLoadingTxt:     'Gathering HiFi Emotions',
        dynamicText:        '',
        introTextTop:       'Select An Emotional World',
        introTextBottom:    'Change Your Mood',
        loadingReassuranceText: '',
        loadingReassuranceTimer: undefined,
        loadingPrecentage:  0,
        muteButtonEngaged:  {
                            'layer1': false,
                            'layer2': true,
                            'layer3': true,
                            // 'layer4': true,
                            // 'layer5': true,
                            // 'layer6': true,
                            },
        isPauseEnabled:    true,
        isBufferPlaying:   false,
        startStopControlTxt: 'Play',
        showSoundscapeSelection: true,
        showInfoPage: false,
        isSelectionMenuActive: false,
    //AUDIO CONTEXT
        audioContext:       undefined,
        allowSpeedControl:  false,
        bufferPlaybackSpeed: 1.00,
        masterAudioObject:  undefined,
        bufferDisplayTime:  '0:00',
        soundscapeIR:       {},
        audioPlayers:   {
                            'layer1': undefined,
                            'layer2': undefined,
                            'layer3': undefined,
                            // 'layer4': undefined,
                            // 'layer5': undefined,
                            // 'layer6': undefined
                        },
        audioGains: {
                            'layer1': undefined,
                            'layer2': undefined,
                            'layer3': undefined,
                            // 'layer4': undefined,
                            // 'layer5': undefined,
                            // 'layer6': undefined
                        },
        fadeTime:       0.05,
    //AUDIO FX
        SpaceSubmix : undefined,
        SpaceSubmixDestroy: undefined,
        ChaosSubmix : undefined,
        CleanSubmix : undefined,
        lfo1:           undefined,
        postDistortionSubMix:undefined,
        convolverSubMix:    undefined,
        delayAudioNode:     undefined,
        delayAmt:           0,
        delayMerger:        undefined,
        leftDelay:          undefined,
        rightDelay:         undefined,
        leftFeedback:       undefined,
        rightFeedback:      undefined,
        delaySplitter:      undefined,
        leftDelayTime:      0.75,
        rightDelayTime:     0.75,    
        leftFeedbackGain:   0.5,    
        rightFeedbackGain:  0.5,    
        convolverNode:      undefined,
        convolverIRBuffer:  undefined,
        filterNode:         undefined,
        filterFrequency:    20000,
        safetyFilter:       undefined,
        IRsafetyFilter:     undefined,
        distortionNode:     undefined,
        distortionAmt:      0,
        postIRDistortionSubMix: undefined,
        IRDistortionNode: undefined,
        layerSliderPosition:       0,
        distortionMax:      1,
        speedGeneratorActive: 2,
    //BUFFER TRACKING
        areBuffersLoaded:   false,
        bufferPercentageLoaded: 0,
        isFirstRun:         true,
        isAudioUnlocked:    false,
        audioBuffers:       {},
        bufferTrackingInterval: undefined,
        userChangingBufferPosition: false,
        bufferPosition:     0,
        bufferRemaining:    0,
        bufferDuration:     0,
        bufferTrackingArray:[],
        loadedSoundscapes:  [],
        amountOfAudioFilesToLoad: 0,
        bufferStartTime:    0,
        playerSeekAmt:      0,
}),
created(){
    document.title = "MOODY BY MATT MCCORKLE";
    if (window.AudioContext || window.webkitAudioContext){
        let AudioContext = window.webkitAudioContext || window.AudioContext; 
        this.$store.state.audioContext = new AudioContext();
    };
    console.log('%c SONIC EXPERIENCE CREATED BY MATT MCCORKLE' , 'background: black; color: gold');
    this.audioContext = this.$store.state.audioContext;
    this.buildSoundscapeObject();
    this.defaultSoundscape = this.masterAudioObject['soundscape1']['soundscapeName'];
    this.initAudio(); 


    this.loadingReassuranceText = 'Creating Web Audio...';
    
    this.loadingReassuranceTimer = setInterval(()=>{ 
        this.demoLoadingTxt = 'Gathering HiFi Emotions'; 
        this.loadingReassuranceText = 'This May Take A Moment';
        setTimeout(()=> { this.demoLoadingTxt = ''; this.loadingReassuranceText = 'This Only Needs\nTo Load Once'; }, 2500); 
    }, 5000);
},
computed:{
    spaceAdjust(){
        soundscapeControl.soundscapeMixing(this.selectedSoundscape, this.layerSliderPosition);
        // console.log(soundscapeControl.soundscapeMixingObject);
        this.dynamicText = soundscapeControl.soundscapeMixingObject.dynamicText;
        this.selectedSoundscapeDisplay = soundscapeControl.soundscapeMixingObject.selectedSoundscapeDisplay;
        document.title = soundscapeControl.soundscapeMixingObject.selectedSoundscapeDisplay.toUpperCase();

        //INTERACTIVE BACKGROUND
        for (let key in this.masterAudioObject){
            if (this.masterAudioObject[key]['soundscapeName'] == this.selectedSoundscape){

                let mainColorDepth = (this.layerSliderPosition * 100), 
                    accentColorDepth = (this.layerSliderPosition * 100 / 2);
                let colorConvert = 'linear-gradient(' + this.masterAudioObject[key]['angle'] +', var(--main-accentBackground)' + mainColorDepth + '%, var(--main-background)' + accentColorDepth + '%) fixed';
                
                document.body.style.setProperty('background', colorConvert);
            };
        };

        if ((!this.isFirstRun) && (this.isBufferPlaying)){

            //BALANCE BETWEEN CLEAN AND CHAOS
            this.CleanSubmix.gain.setValueAtTime(soundscapeControl.soundscapeMixingObject.CleanSubmix , this.audioContext.currentTime);

            //AUDIO BUFFER LAYERS
            this.audioGains['layer1'].gain.setTargetAtTime(
                parseFloat(soundscapeControl.soundscapeMixingObject.audioGainLayer1), this.audioContext.currentTime, 0.5);
            this.audioGains['layer2'].gain.setTargetAtTime(
                parseFloat(soundscapeControl.soundscapeMixingObject.audioGainLayer2), this.audioContext.currentTime, 0.5);
            this.audioGains['layer3'].gain.setTargetAtTime(
                parseFloat(soundscapeControl.soundscapeMixingObject.audioGainLayer3), this.audioContext.currentTime, 0.5);
        };
    },
},
methods: {  
    buildSoundscapeObject(){
        let ua = window.navigator.userAgent;
        let isChrome;
        if(navigator.userAgent.search("Chrome") > 0){
            isChrome = true;
        }
        let isFirefox = typeof InstallTrigger !== 'undefined';
        let isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
        let isOpera = !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
        let isIE = false || !!document.documentMode;
        let isEdge = !this.isIE && !!window.StyleMedia;
        let isBlink = (this.isChrome || this.isOpera) && !!window.CSS;
        let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
        let AndroidMobile = /Android/i.test(navigator.userAgent);

        let loadType, loadPath;

        if (isSafari || iOS){
            this.iOSUser  = true;
            loadType   = ".m4a";
            loadPath = "/m4a/";
        } else if (isChrome || isFirefox || AndroidMobile){
            loadType   = ".ogg";
            loadPath = "/ogg/";
        } else {
            loadType   = ".mp3";
            loadPath = "/mp3/";
        };

        // loadType   = ".wav";
        // loadPath = "/wav/";

        console.log('%c moody is using the ' + loadType + ' audio format' , 'background: black; color: gold');

    
        soundscapeControl.buildObject(loadType, loadPath);
        this.masterAudioObject = soundscapeControl.soundscapeObject;
    },
    initAudio(){
        for (let i = 1; i <= Object.keys(this.masterAudioObject).length; i++){
            let soundscape = 'soundscape' + i;

            this.audioBuffers[this.masterAudioObject[soundscape]['soundscapeName']] = this.masterAudioObject[soundscape]['soundscapeName'];
            this.audioBuffers[this.masterAudioObject[soundscape]['soundscapeName']] = {
                layer1: 'bufferNotLoaded',
                layer2: 'bufferNotLoaded',
                layer3: 'bufferNotLoaded',
                // layer4: 'bufferNotLoaded',
                // layer5: 'bufferNotLoaded',
                // layer6: 'bufferNotLoaded',
            };

            for (let n = 1; n <= Object.keys(this.masterAudioObject[soundscape]).length; n++){
                let layer = 'layer' + n;

                if (this.masterAudioObject[soundscape][layer] != undefined || null || NaN){
                    
                    let loadFromStorage = (url, value) => {
        
                        let fileReader = new FileReader();
                            fileReader.onload = (event) => {
                                this.audioContext.decodeAudioData(event.target.result, (buffer) => { 
                                        this.audioBuffers[this.masterAudioObject[soundscape]['soundscapeName']][layer] = buffer;
                                });
                        };
                        fileReader.readAsArrayBuffer(value);
                        // console.log('%c Loaded Files From indexDB ' , 'background: pink; color: black');
                    };

                    
                    let loadFromSystem = (url, value) => {
                        
                        let request = new XMLHttpRequest();
                            request.open('GET', url, true);
                            request.responseType = 'blob';
                        
                        request.onload = () => {
                            //Set Item
                            localForage.setItem(url, request.response) .then ( (value) => { 
                                //Wait for item to be set, then get
                                localForage.getItem(this.masterAudioObject[soundscape][layer], (err, value) => {
                                        //pass item to loadFromStorage
                                        loadFromStorage(this.masterAudioObject[soundscape][layer], value);
                                    }).catch((err) => {
                                });                
                          }).catch(function(err){ 
                            // console.log(err); 
                        });
                        }
                        request.send();
                        
                    };

                    localForage.getItem(this.masterAudioObject[soundscape][layer], (err, value) => {
                        if (value != null || undefined || NaN){
                            loadFromStorage(this.masterAudioObject[soundscape][layer], value);
                        } else if (value == null || undefined || NaN){
                            loadFromSystem(this.masterAudioObject[soundscape][layer], value);
                        }
                        }).catch((err) => {
                    });                
                this.amountOfAudioFilesToLoad++;
                }
            };
        };

        let keyLoader = [];
        for (let key in this.audioBuffers){
            for (let n = 1; n <= Object.keys(this.audioBuffers[key]).length; n++){
                let layer = 'layer' + n;
                if (this.audioBuffers[key][layer] == 'bufferNotLoaded') {
                    if (!keyLoader.includes(key)) { 
                        keyLoader.push(key + '_' + layer) 
                    };
                };
            };
            this.loadedSoundscapes.push(key)
        };

        this.bufferTrackingInterval = setInterval(() => { 
            this.bufferLoadingTracking(keyLoader); 
        }, 100);  

        this.createKeyCommands();
        this.createFXChain();
    },
    createKeyCommands(){
        document.ontouchmove = function (e) {
          e.preventDefault();
        };

        // window.addEventListener("orientationchange", () => {
            // console.log("the orientation of the device is now " + screen.orientation.angle);
            // if (screen.orientation.angle == 180){
                // window.scrollTo(0, 0);/
            // }
        // });

        $(document).ready(() => {
    
            $('#soundscapeSelectionBay').on('show.bs.dropdown', () => {
                // console.log("Opening dropdown..");
            });
            
            $('#soundscapeSelectionBay').on('shown.bs.dropdown', () => {
                // console.log("Dropdown opened..");
            });
            
            $('#soundscapeSelectionBay').on('hide.bs.dropdown', () => {
                // console.log("Hiding dropdown..");
            });
            
            $('#soundscapeSelectionBay').on('hidden.bs.dropdown', () => {
                // console.log("Dropdown hidden..");
                this.isSelectionMenuActive = false;
            });

        });

        window.addEventListener('keydown', (e) => {
            // console.log(e)
            switch(e.code){
                case 'Space':
                    e.preventDefault();
                    this.startStopControl();
                break;
                case 'ArrowUp':
                    // e.preventDefault();
                    if (this.bufferPlaybackSpeed > 2) { this.bufferPlaybackSpeed = 2; } else { this.speedControl(this.bufferPlaybackSpeed++); }
                    console.log('ArrowUp')
                break;
                case 'ArrowRight':
                    // e.preventDefault();
                    this.bufferChangePosition(this.bufferPosition++);
                    console.log('ArrowRight')
                break;
                case 'ArrowLeft':
                    // e.preventDefault();
                    this.bufferChangePosition(this.bufferPosition--);
                    console.log('ArrowLeft')
                break;
                case 'ArrowDown':
                    // e.preventDefault();
                    if (this.bufferPlaybackSpeed < 0.25) { this.bufferPlaybackSpeed = 0.25; } else { this.speedControl(this.bufferPlaybackSpeed--); }
                    console.log('ArrowDown')
                break;
                case 'KeyQ':
                    e.preventDefault();
                break;
                case 'KeyE':
                    e.preventDefault();
                break;
                case 'KeyW':
                    e.preventDefault();
                break;
                default:
                break;
            };
        }, true);
    },
    makeDistortionCurve(amount) {
        let k = typeof amount === 'number' ? amount : 50,
            n_samples = 48000,
            curve = new Float32Array(n_samples),
            deg = Math.PI / 180,
            i = 0,
            x;
        for ( ; i < n_samples; ++i ) {
            x = i * 2 / n_samples - 1;
            curve[i] = ( 3 + k ) * x * 20 * deg / ( Math.PI + k * Math.abs(x) );
        }
          return curve;
    },
    createFXChain(){
        // this.ChaosSubmix = this.audioContext.createGain();
        this.CleanSubmix = this.audioContext.createGain();
        // this.ChaosSubmix.gain.value = 0;
        this.CleanSubmix.gain.value = 1;
        //PINGPONG DELAY
            // this.delayMerger = this.audioContext.createChannelMerger(2);
            // this.leftDelay = this.audioContext.createDelay();
            // this.rightDelay = this.audioContext.createDelay();
            // this.leftFeedback = this.audioContext.createGain();
            // this.rightFeedback = this.audioContext.createGain();
            // this.delaySplitter = this.audioContext.createChannelSplitter(2);

            // Split the stereo signal.
            // this.delaySplitter.connect( this.leftDelay, 0 );
            // this.delaySplitter.connect( this.rightDelay, 1 );

            // this.leftDelay.delayTime.value = this.leftDelayTime;
            // this.rightDelay.delayTime.value = this.rightDelayTime;

            // this.leftFeedback.gain.value = this.leftFeedbackGain;
            // this.rightFeedback.gain.value = this.rightFeedbackGain;

            // Connect the routing - left bounces to right, right bounces to left.
            // this.leftDelay.connect(this.leftFeedback);
            // this.leftFeedback.connect(this.rightDelay);

            // this.rightDelay.connect(this.rightFeedback);
            // this.rightFeedback.connect(this.leftDelay);

            // Re-merge the two delay channels into stereo L/R
            // this.leftFeedback.connect(this.delayMerger, 0, 0);
            // this.rightFeedback.connect(this.delayMerger, 0, 1);
            // Now connect your input to "splitter", and connect "merger" to your output destination.
        //FILTER
            // this.safetyFilter  = this.audioContext.createBiquadFilter();
            // this.safetyFilter.type = "lowpass";
            // this.safetyFilter.frequency.value = 20000;
        //DESTROY
            // this.postDistortionSubMix = this.audioContext.createGain();
            // this.distortionNode = this.audioContext.createWaveShaper();
            // this.distortionNode.oversample = '4x';
            // this.distortionNode.curve = this.makeDistortionCurve(5);
        //LFO
            // this.lfo1 = this.audioContext.createOscillator();
            // this.lfo1.type = 'square';
            // this.lfo1.frequency.value = 30;
            // this.lfo1.connect(this.ChaosSubmix.gain);
            // this.lfo1.start();
        //FINAL BUSS CONNECTIONS
            this.CleanSubmix
            .connect(this.audioContext.destination);    

            // this.ChaosSubmix
            // .connect(this.distortionNode)
            // .connect(this.safetyFilter)
            // .connect(this.postDistortionSubMix)
            // .connect(this.delayMerger)
            // .connect(this.audioContext.destination);

            // console.log('%c Audio SFX Built ' , 'background: lightgreen; color: black');
            // console.log('%c Audio Signal Flow Routed ' , 'background: lightgreen; color: black');
    },
    bufferLoadingTracking(keyLoader){
        for (let key in this.audioBuffers){
            for (let n = 1; n <= Object.keys(this.audioBuffers[key]).length; n++){
                let layer = 'layer' + n;
                if (this.audioBuffers[key][layer] != 'bufferNotLoaded') {

                    const index = keyLoader.indexOf(key + '_' + [layer]);
                    if (index > -1) {
                      keyLoader.splice(index, 1);
                    }

                };
            };
        };

        this.bufferPercentageLoaded = keyLoader.length / this.amountOfAudioFilesToLoad;
        // console.log(this.bufferPercentageLoaded);
        // console.log(keyLoader.length);

            if ((this.bufferPercentageLoaded < 1) && (this.bufferPercentageLoaded > 0.90)){
                if (this.loadingReassuranceTimer != undefined) { clearInterval(this.loadingReassuranceTimer); this.loadingReassuranceTimer = undefined; };
                this.demoLoadingTxt = "Gathering HiFi Emotions";
            } else if ((this.bufferPercentageLoaded < 0.9) && (this.bufferPercentageLoaded > 0.80)){
                this.demoLoadingTxt = "Parsing Emotions";
            } else if ((this.bufferPercentageLoaded < 0.8) && (this.bufferPercentageLoaded > 0.70)){
                this.demoLoadingTxt = "Chatting With The Birds";
            } else if ((this.bufferPercentageLoaded < 0.7) && (this.bufferPercentageLoaded > 0.60)){
                this.demoLoadingTxt = "Whispering With The Wind";
            } else if ((this.bufferPercentageLoaded < 0.6) && (this.bufferPercentageLoaded > 0.50)){
                this.demoLoadingTxt = "Convening With The Trees";
            } else if ((this.bufferPercentageLoaded < 0.5) && (this.bufferPercentageLoaded > 0.40)){
                this.demoLoadingTxt = "Abstracting Audio Elements";
            } else if ((this.bufferPercentageLoaded < 0.4) && (this.bufferPercentageLoaded > 0.30)){
                this.demoLoadingTxt = "Applying Sonic Enchancements";
            } else if ((this.bufferPercentageLoaded < 0.3) && (this.bufferPercentageLoaded > 0.20)){
                this.demoLoadingTxt = "Preparing Speakers";
            } else if ((this.bufferPercentageLoaded < 0.2) && (this.bufferPercentageLoaded > 0.05)){
                this.demoLoadingTxt = "Generating Emotional Worlds";
            }  else if ((this.bufferPercentageLoaded < 0.05) && (this.bufferPercentageLoaded > 0)){
                this.demoLoadingTxt = "Almost Ready!";
            } 

            function convertRange( value, r1, r2 ) { 
                return ( value - r1[ 0 ] ) * ( r2[ 1 ] - r2[ 0 ] ) / ( r1[ 1 ] - r1[ 0 ] ) + r2[ 0 ];
            };

            this.loadingPrecentage = Math.round(((convertRange( this.bufferPercentageLoaded, [ 1, 0 ], [ 0, 1 ] )) * 100));

            let mainColorDepth = (this.bufferPercentageLoaded * 100), 
                accentColorDepth = (this.bufferPercentageLoaded * 100 / 2);
            let colorConvert = 'linear-gradient(-45deg, rgba(0, 0, 0, 0.5) ' + mainColorDepth + '%, white ' + accentColorDepth + '%) fixed';
                
            document.body.style.setProperty('background', colorConvert);

            // console.log(colorConvert);
            
        if (keyLoader.length == 0){
            clearInterval(this.loadingReassuranceTimer);
            clearInterval(this.bufferTrackingInterval);
            this.bufferTrackingInterval = undefined;
            this.initalizeAudioNewScene(this.defaultSoundscape);
            this.areBuffersLoaded = true;
            // console.log('%c Audio Buffers Loaded ' , 'background: lightgreen; color: black');
        };
    },
    createAudioPlayers(){

        for (let i = 1; i <= Object.keys(this.audioPlayers).length; i++){
            let string = 'layer' + i;

            //Create Gain Nodes
            this.audioGains[string]   = undefined; 
            this.audioGains[string]   = this.audioContext.createGain();
            this.audioGains[string].gain.value = 0;

            //Create Players
            this.audioPlayers[string] = this.audioContext.createBufferSource();
            this.audioPlayers[string].loop = true;
            
            //Connect Audio Nodes
            this.audioPlayers[string]
            .connect(this.audioGains[string])
            .connect(this.CleanSubmix);

            //Point Buffer To Player
            this.audioPlayers[string].buffer = this.audioBuffers[this.selectedSoundscape][string];

            //Set Playback Speed and Start Buffers
            this.audioPlayers[string].playbackRate.value = this.bufferPlaybackSpeed;
            this.audioPlayers[string].start(this.audioContext.currentTime, this.playerSeekAmt % this.audioPlayers[string].buffer.duration);  
        };

            //Buffer Timing Cleanup and Start
            this.bufferStartTime = this.audioContext.currentTime;
            this.bufferDuration = this.audioPlayers['layer1'].buffer.duration;
            clearInterval(this.bufferTrackingInterval);
            this.bufferTrackingInterval = undefined;
            this.bufferTrackingInterval = setInterval(() => { 
                this.trackBuffer(); 
            }, 100); 

            this.isBufferPlaying = true;

            if (!this.isFirstRun) { this.startStopControlTxt = 'Pause'; }
    },
    fadeOutAudio(){
        let fadeTime = 0.05;

        // this.SpaceSubmix.gain.setValueAtTime(0, this.audioContext.currentTime + this.fadeTime);
        this.CleanSubmix.gain.setValueAtTime(0, this.audioContext.currentTime + this.fadeTime);
        for (let i = 1; i <= Object.keys(this.audioGains).length; i++){
            let string = 'layer' + i;
            this.audioGains[string].gain.setTargetAtTime(0, this.audioContext.currentTime, this.fadeTime);
        };
    }, 
    stopAllAudio(){
        clearInterval(this.bufferTrackingInterval);
        this.bufferTrackingInterval = undefined;

        for (let i = 1; i <= Object.keys(this.audioGains).length; i++){
            let string = 'layer' + i;
            this.audioGains[string].gain.setTargetAtTime(0, this.audioContext.currentTime, 0.05);
            this.audioGains[string] = undefined; 
        };

        for (let i = 1; i <= Object.keys(this.audioPlayers).length; i++){
            let string = 'layer' + i;
            setTimeout( () => { 
                this.audioPlayers[string].stop(); 
                this.audioPlayers[string] = undefined; 
            }, 250);
            
        };
        this.isBufferPlaying = false;
        this.startStopControlTxt = 'Play';

        // console.log('%c Buffer Players Stopped ' , 'background: red; color: black');
    },
    startStopControl(){
        this.isPauseEnabled = !this.isPauseEnabled;
        if (!this.isPauseEnabled){
            this.createAudioPlayers(); 
            this.allowSpeedControl = true;
        } else if (this.isPauseEnabled){    
            this.allowSpeedControl = false;
            this.playerSeekAmt = this.bufferPosition;
            this.stopAllAudio();
        };
        if (!this.isAudioUnlocked) { StartAudioContext(this.audioContext, "#mainDiv"); }
        if (this.audioContext.state == 'interrupted') { this.audioContext.resume(); }
    },
    initalizeAudioNewScene(soundscape){
        if (this.selectedSoundscape != soundscape){
            document.title = soundscape.toUpperCase();
            this.selectedSoundscape = soundscape;
            this.playerSeekAmt = 0;
            this.layerSliderPosition = 0;
            if (!this.isFirstRun) { 
                if (this.isBufferPlaying) { 
                    this.stopAllAudio(); 
                    this.bufferPosition = 0;
                    // this.bufferDisplayTime = this.functionFancyTime(this.bufferPosition);
                    this.speedGeneratorActive = 2;
                    this.bufferPlaybackSpeed = 1; this.speedControl(this.bufferPlaybackSpeed);
                    this.isPauseEnabled = true;
                } else if (!this.isBufferPlaying) { }
            };

            this.isFirstRun = false;
            for (let key in this.masterAudioObject){
                if (this.masterAudioObject[key]['soundscapeName'] == soundscape){
                    document.body.style.setProperty('--main-background', this.masterAudioObject[key]['--main-background']);
                    document.body.style.setProperty('--main-accentBackground', this.masterAudioObject[key]['--main-accentBackground']);
                    document.body.style.setProperty('--main-textColor', this.masterAudioObject[key]['--main-textColor']); 
                    document.body.style.setProperty('--main-sliderColor', this.masterAudioObject[key]['--main-sliderColor']);
                    document.body.style.setProperty('--main-sliderTextColor', this.masterAudioObject[key]['--main-sliderTextColor']);
                }
            };
            
            switch(soundscape){
                case `moody intro`:
                case `Joy`:
                case `Interest`:
                case `Trust`:
                case `Sadness`:
                case `Disgust`:
                    document.body.style.setProperty('--main-creditColor', 'black'); 
                break;
                case `Anger`:
                case `Distraction`:
                case `Fear`:
                    document.body.style.setProperty('--main-creditColor', 'white'); 
                break;
            }
            

            this.isSelectionMenuActive = false;
        };
    },
    speedControl(speed){
      if (this.allowSpeedControl){
        for (let key in this.audioPlayers){
            this.audioPlayers[key].playbackRate.setTargetAtTime(speed, this.audioContext.currentTime, 0.5);
        };
      };
    },
    speedGenerator(){
        this.speedGeneratorActive++;
        if (this.speedGeneratorActive > 3){
            this.speedGeneratorActive = 1
        };
        switch(this.speedGeneratorActive){
            case 1:
                this.bufferPlaybackSpeed = 0.5; this.speedControl(this.bufferPlaybackSpeed);
            break;
            case 2:
                this.bufferPlaybackSpeed = 1; this.speedControl(this.bufferPlaybackSpeed);
            break;
            case 3:
                this.bufferPlaybackSpeed = 1.35; this.speedControl(this.bufferPlaybackSpeed);
            break;
        };
    },
    muteControl(layer){
        this.muteButtonEngaged[layer] = !this.muteButtonEngaged[layer];

        if (this.muteButtonEngaged[layer]){
            this.audioGains[layer].gain.setTargetAtTime(0, this.audioContext.currentTime, 0.1);
        } else if (!this.muteButtonEngaged[layer]){
            this.audioGains[layer].gain.setTargetAtTime(1, this.audioContext.currentTime, 0.1);
        };
    },  
    functionFancyTime(time){
        let hrs = ~~(time / 3600);
        let mins = ~~((time % 3600) / 60);
        let secs = ~~time % 60;
        let ret = "";
        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }

        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        return ret;
    },
    trackBuffer(){
        this.bufferPosition = ((((this.audioContext.currentTime - this.bufferStartTime) 
                    * this.bufferPlaybackSpeed) % this.bufferDuration)
                    + this.playerSeekAmt);

        this.bufferRemaining = (this.audioPlayers['layer1'].buffer.duration - this.bufferPosition);

        if (this.bufferPosition >= this.audioPlayers['layer1'].buffer.duration){
            this.playerSeekAmt  = 0;
            this.bufferStartTime = this.audioContext.currentTime;
        };

        if ((this.bufferPosition > 0) && (!this.isAudioUnlocked)) { 
            this.isAudioUnlocked = true; 
            // console.log('%c Web Audio Playback Unlocked ' , 'background: lightgreen; color: black');
        };

        // this.bufferDisplayTime = this.functionFancyTime(this.bufferPosition);
    },
    bufferChangePosition(changeTo){
        this.playerSeekAmt = changeTo;
        // this.bufferDisplayTime = this.functionFancyTime(changeTo);
        if (this.isBufferPlaying){
            this.stopAllAudio();  
            setTimeout(()=> { 
                this.createAudioPlayers(); 
            },  300); 
        };
    },
    showHideSelection(showing){
        switch(showing){
            case 'infoBar':
                this.showInfoPage = !this.showInfoPage;
            break;
            case 'selectionBar':
                this.showSoundscapeSelection = !this.showSoundscapeSelection;
            break;
            default:
            break;
        };
    },
    activateOpacity(){
        this.isSelectionMenuActive = !this.isSelectionMenuActive;

        if (this.isSelectionMenuActive){

        } else if (!this.isSelectionMenuActive){

        };
    },
    goToMcCookie(){
        window.open('http://www.mattmccorkle.com','_blank');
        this.isSelectionMenuActive = false;
    },
  }
}
</script>